import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import logo from 'assets/images/logo-2-color.svg';
import { ReactComponent as ArrowLeft } from 'assets/icons_3/arrows/arrow-left.svg';
import { ReactComponent as UserIcon } from 'assets/icons_3/user.svg';
import RouterLinkButton from 'components/UI_kit_3/Button/RouterLinkButton';
import RegistrationForm from 'components/SelfRegistration/RegistrationForm/RegistrationForm';
import LanguageSelector from 'components/LanguageSelector/LanguageSelector';
import { getUtm } from 'components/SelfRegistration/utm';

import styles from './registration-page.module.scss';

const RegistrationPage = () => {
  const [t] = useTranslation();

  // метки из ссылки запоминаются при заходе на страницу, до отправки кода
  React.useEffect(() => {
    getUtm();
  }, []);

  return (
    <main className={styles.registrationPage}>
      <Helmet>
        <title>{`${t('auth.signup')} | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
      </Helmet>
      <LanguageSelector className={styles.lang} />
      <div className={styles.logo}>
        <img src={logo} width={173} height={40} alt="pro-data" />
      </div>
      <div className={styles.icon}>
        <UserIcon />
      </div>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('self_registration.title')}</h1>
        <div className={styles.subTitle}>{t('self_registration.subtitle')}</div>
        <RegistrationForm />
        <RouterLinkButton variant="link-gray" prefixIcon={<ArrowLeft />} to="/" replace qa-element="to-main">
          {t('self_registration.back_to_login')}
        </RouterLinkButton>
      </div>
      <div className={styles.rights}>
        {window.location.host.includes('kz-1') ? t('common.rights_kz') : t('common.rights')}
      </div>
    </main>
  );
};

export default RegistrationPage;
